module.exports = __webpack_public_path__ + "img/wmv.35e4e883.svg";